import React, { createContext, useState, useContext } from 'react';

const FavoritedEventsContext = createContext(null);

export default function FavoritedEventsProvider({ children }) {
    const [favoritedEvents, setFavoritedEvents] = useState([]);

    function addFavorite(event) {
        setFavoritedEvents(prev =>
            prev.find(e => e.slug === event.slug) ? prev : [event, ...prev]
        );
    }

    function removeFavorite(slug) {
        setFavoritedEvents(prev => prev.filter(e => e.slug !== slug));
    }

    return (
        <FavoritedEventsContext.Provider value={{ favoritedEvents, setFavoritedEvents, addFavorite, removeFavorite }}>
            {children}
        </FavoritedEventsContext.Provider>
    );
}

export function useFavoritedEvents() {
    const ctx = useContext(FavoritedEventsContext);
    if (!ctx) throw new Error('useFavoritedEvents must be used within FavoritedEventsProvider');
    return ctx;
}

// Optional version — does not throw if used outside provider (for useFavorite hook)
export function useFavoritedEventsOptional() {
    return useContext(FavoritedEventsContext);
}
